module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-flex', {
    attrs: {
      "offset-md8": "",
      "offset-sm6": "",
      "offset-xs1": ""
    }
  }, [_c('customer-expense', {
    staticClass: "location-component",
    attrs: {
      "label": "GASTO TOTAL",
      "amount": _vm.customerAmount
    }
  })], 1), _vm._v(" "), _c('v-tabs', {
    staticClass: "checkin-tabs pos-tabs",
    attrs: {
      "grow": ""
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tabs-bar', {
    staticClass: "transparent"
  }, [_c('v-tabs-slider', {
    staticClass: "default-skyblue"
  }), _vm._v(" "), _vm._l((_vm.tabs), function(tab) {
    return _c('v-tabs-item', {
      key: tab.id,
      attrs: {
        "href": ("#tab-" + (tab.id))
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(tab.title) + "\n\t\t\t")])
  })], 2), _vm._v(" "), _c('v-tabs-items', [_c('v-tabs-content', {
    attrs: {
      "id": "tab-1"
    }
  }, [(_vm.detailsActive) ? _c('customer-details', {
    attrs: {
      "customer-info": _vm.currentCustomer
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-tabs-content', {
    attrs: {
      "id": "tab-2"
    }
  }, [(_vm.statisticsActive) ? _c('statistics') : _vm._e()], 1), _vm._v(" "), _c('v-tabs-content', {
    attrs: {
      "id": "tab-3"
    }
  }, [(_vm.recordActive) ? _c('record') : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15bd6134","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/customers/New-Customer.vue
// module id = 1589
// module chunks = 2